import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingCaseFormat } from '@euler/model/coaching';
import {
  CoachingPracticeReportView,
  CoachingPracticeSpeaker,
} from '@euler/model/coaching-practice';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';
import { Chip } from '../../../components/Chip';
import { kDrillResultLabels, kEndingLabels } from '../../practiceCopy';
import { ReportSection } from './ReportSection';
import { StarRow } from './StarRow';

function starsText(stars: number) {
  return `${'★'.repeat(stars)}${'☆'.repeat(3 - stars)}`;
}

/** How it ended, the stars against the best before, and who the customer was. */
export const ReportOutcome = memo(
  ({ report }: { report: CoachingPracticeReportView }) => {
    const { rpx } = useResponsiveContext();
    const drill = report.format === CoachingCaseFormat.Drill;
    const tag = drill
      ? report.end.drillResult && kDrillResultLabels[report.end.drillResult]
      : report.end.ending && kEndingLabels[report.end.ending];
    const exchanges = report.transcript.filter(
      x => x.speaker === CoachingPracticeSpeaker.Trainee,
    ).length;
    return (
      <ReportSection style={{ gap: 0 }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: rpx(8),
          }}
        >
          {tag ? (
            <Chip text={tag} color={aiColors.accentForeground} />
          ) : (
            <View />
          )}
          <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
            {`${exchanges} 个来回`}
          </Typography.Text>
        </View>
        <Typography.Text
          size={rpx(18)}
          bold
          color={aiColors.foreground}
          style={{ marginTop: rpx(10), lineHeight: rpx(24) }}
        >
          {report.outcome ?? report.title}
        </Typography.Text>
        <Typography.Text
          size={rpx(12)}
          color={aiColors.mutedForeground}
          style={{ marginTop: rpx(4) }}
        >
          {`本次场景：${report.variationLabel}`}
        </Typography.Text>
        {report.stars != null ? (
          <View
            style={{
              marginTop: rpx(12),
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderRadius: rpx(12),
              backgroundColor: aiColors.muted,
              paddingHorizontal: rpx(12),
              paddingVertical: rpx(10),
            }}
          >
            <StarRow stars={report.stars} size={rpx(20)} />
            {report.previousBest != null ? (
              <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
                {`上次 ${starsText(report.previousBest)}`}
              </Typography.Text>
            ) : null}
          </View>
        ) : null}
      </ReportSection>
    );
  },
);
